import React from 'react';
import { loadStripe } from "@stripe/stripe-js";
import { Container, Spinner } from 'react-bootstrap';
import {
    CardElement,
    Elements,
    useElements,
    useStripe,
    CardElementComponent
} from "@stripe/react-stripe-js";
const ELEMENTS_OPTIONS = {
    fonts: [
        {
            cssSrc: "https://fonts.googleapis.com/css?family=Roboto"
        }
    ]
};




export type IWrapperStripeChargeCardProps = {
    publishableKey: string
    onFinishedLoad(stripe): void

}


const LoadElementsStripe: React.FC<IWrapperStripeChargeCardProps> = (props) => {
    const [stripePromise, setStripePromise] = React.useState(null)
    React.useEffect(() => {
        // const retrievePublishableKey = async () => {
        //     const publishableKey = await publishableKeyGet()
        //     console.log("publishableKey",publishableKey)
        //     const stripe = loadStripe(publishableKey);
        //     setStripePromise(stripe)
        // }
        // retrievePublishableKey()
    }, []);


    React.useEffect(() => {

        initloadStripe()

    }, [])

    const initloadStripe = async () => {
        const stripe = await loadStripe(props.publishableKey);
        setStripePromise(stripe)
        props.onFinishedLoad(stripe)
    }
    // console.log("stripePromise", stripePromise)
    if (!stripePromise) {
        return (
            <>
                {props.children}
            </>
        )
    }



    return (
        <Elements stripe={stripePromise} options={ELEMENTS_OPTIONS}>
            {props.children}
        </Elements>
    );
}


LoadElementsStripe.defaultProps = {

}
export { LoadElementsStripe };